import { Component } from '@angular/core';
import { SiteNavigationService } from '../../../core-services';

@Component({
    selector: 'global-nav-zazzbar',
    templateUrl: './global-nav-zazzbar.component.html',
    styleUrls: ['./global-nav-zazzbar.component.less'],
    standalone: false
})
export class GlobalNavZazzbarComponent {
    constructor(private siteNavigation: SiteNavigationService) {}

    currentModuleClassName(): string {
        if (this.siteNavigation.isInDiagnose) {
            return 'global-nav__zazzbar--diagnose';
        } else if (this.siteNavigation.isInHire) {
            return 'global-nav__zazzbar--hire';
        } else if (
            this.siteNavigation.isInDesign ||
            this.siteNavigation.isInDesign2
        ) {
            return 'global-nav__zazzbar--design';
        } else if (
            this.siteNavigation.isInInspire ||
            this.siteNavigation.isInInspire2
        ) {
            return 'global-nav__zazzbar--inspire';
        } else {
            return 'global-nav__zazzbar--main';
        }
    }
}
